import Cookies from 'js-cookie'
// import { setStore, getStore, removeStore } from './store';
const TokenKey = 'saber-access-token'
const RefreshTokenKey = 'saber-refresh-token'
export function getToken () {
  return Cookies.get(TokenKey)
  // return getStore({ name: TokenKey })
  // return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
  // return setStore({ name: TokenKey, content: token, type: true })
}

export function getRefreshToken () {
  return Cookies.get(RefreshTokenKey)
  // return getStore({ name: RefreshTokenKey })
  // return Cookies.get(RefreshTokenKey)
}

export function setRefreshToken (token) {
  return Cookies.set(RefreshTokenKey, token)
  // return setStore({ name: RefreshTokenKey, content: token, type: 'string' })
  // return Cookies.set(RefreshTokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
  // return removeStore({ name: TokenKey, type: true })
  // return Cookies.remove(TokenKey)
}

export function removeRefreshToken () {
  return Cookies.remove(RefreshTokenKey)
  // return removeStore({ name: RefreshTokenKey, type: true })
  // return Cookies.remove(RefreshTokenKey)
}
